export default __webpack_public_path__ + "static/media/sample_based_learningmethods.1fec94ef.png";